export type DeltaType = 'Added' | 'Removed' | 'Changed' | 'None' | null | undefined;

export interface Delta {
    property?: string,
    deltaType?: DeltaType,
    originalValue?: any,
    currentValue?: any
}

export const BrandProperties = {
    Name: 'Name' as const,
    BrandType: 'BrandType' as const,
    BrandStateCategory: 'BrandStateCategory' as const,
    BrandState: 'BrandState' as const,
    RegistrationNumber: 'RegistrationNumber' as const,
    ApplicationNumber: 'ApplicationNumber' as const,
    ExpiryDate: 'ExpiryDate' as const,
    ApplicationDate: 'ApplicationDate' as const,
    RegistrationDate: 'RegistrationDate' as const,
    OppositionPeriodEndDate: 'OppositionPeriodEndDate' as const,
    OwnerAddress: 'OwnerAddress' as const,
    GoodsServices: 'GoodsServices' as const,
    NiceClasses: 'NiceClasses' as const,
    ViennaClasses: 'ViennaClasses' as const,
    Processes: 'Processes' as const,
} as const;
